// import _ from 'lodash';
import * as d3 from 'd3';
import * as d3Nest from 'd3-collection';
// import isNumber from 'is-number';

/* eslint-disable */
function makeChart(chartConfigObject, jsonData, lookup) {
  // chart variables
  const { chartDesc } = chartConfigObject; // 508 compliance
  const barColors = chartConfigObject.colorsArrStr;
  const barDataValues = []; // ordered by json order
  const xAxisCategoryNames = [];
  const { yAxisTitle } = chartConfigObject;
  const legendTitle = chartConfigObject.legendTitleStr;
  const legendCategoryNames = [];
  let legendEntryCount = [];
  const confidenceIndicators = [];
  const { decimalPlaces } = chartConfigObject;
  const tooltipDisplay = [];
  const { chartDivId } = chartConfigObject;
  const { dataValueSuffix } = chartConfigObject;
  const xAxisLabelMaxWidth = 120; // label max width

  // data used to process chart variables
  const { xAxisColumn } = chartConfigObject;
  const { xAxisType } = chartConfigObject;
  const xAxisCategoryDataCodes = [];
  const { legendColumn } = chartConfigObject;
  const { legendType } = chartConfigObject;

  d3.selectAll(`#${chartDivId} > *`).remove(); // clear previous chart

  d3.select(`#${chartDivId}`).append('canvas').attr('width', 700).attr('height', '340'); // add canvas element
  const sortedJsonData = jsonData.sort((a, b) => { // sort data (x-axis responses display by ascending sort number)
    const sortColA = a[xAxisColumn];
    const sortColB = b[xAxisColumn];
    if (lookup[xAxisType][sortColA].sort < lookup[xAxisType][sortColB].sort) { return -1; }
    if (lookup[xAxisType][sortColB].sort < lookup[xAxisType][sortColA].sort) { return 1; }
    return 0;
  });
  function makeTooltipDisplay(obj) {
    let hciNum;
    let lciNum;
    let valNum;
    const column = obj[xAxisColumn];
    const title = lookup[xAxisType][column].name;
    let wn = String(obj.wn);
    if (wn.length > 3 && wn.length < 7) {
      wn = wn.split('').reverse().join('');
      wn = `${wn.substring(0, 3)},${wn.substring(3)}`;
      wn = wn.split('').reverse().join('');
    } else if (wn.length > 6 && wn.length < 10) {
      wn = wn.split('').reverse().join('');
      wn = `${wn.substring(0, 3)},${wn.substring(3, 6)},${wn.substring(6)}`;
      wn = wn.split('').reverse().join('');
    }
    // handle decimals
    if (obj.hci >= 0 && obj.hci != null) {
      let hciArr = obj.hci.toString().split('');
      switch (hciArr.indexOf('.') >= 0) { // hci
        case true:
          hciArr = hciArr.join('');
          hciNum = Number(hciArr);
          break;
        case false:
          hciArr = hciArr.join('');
          hciArr = Number(hciArr);
          hciNum = hciArr.toFixed(decimalPlaces);
          break;
        default:
          break;
      }
    }
    if (obj.lci >= 0 && obj.lci != null) {
      let lciArr = obj.lci.toString().split('');
      switch (lciArr.indexOf('.') >= 0) { // lci
        case true:
          lciArr = lciArr.join('');
          lciNum = Number(lciArr);
          break;
        case false:
          lciArr = lciArr.join('');
          lciArr = Number(lciArr);
          lciNum = lciArr.toFixed(decimalPlaces);
          break;
        default:
          break;
      }
    }
    if (obj.dv >= 0 && obj.dv != null) {
      let valArr = obj.dv.toString().split('');
      switch (valArr.indexOf('.') >= 0) { // val
        case true:
          valArr = valArr.join('');
          valNum = Number(valArr);
          break;
        case false:
          valArr = valArr.join('');
          valArr = Number(valArr);
          valNum = valArr.toFixed(decimalPlaces);
          break;
        default:
          break;
      }
    }
    tooltipDisplay.push({
      title,
      dv: valNum || obj.dv,
      dataValueSuffix: chartConfigObject.dataValueSuffix,
      lci: lciNum || obj.lci,
      hci: hciNum || obj.hci,
      sampleSizeLabel: chartConfigObject.sampleSizeLabel,
      wn,
    });
  }
  sortedJsonData.forEach((obj) => { // process data
    if (xAxisCategoryDataCodes.indexOf(obj[xAxisColumn]) < 0) { // save data codes. then, map titles.
      xAxisCategoryDataCodes.push(obj[xAxisColumn]);
    }
    const confidenceIndicator = { lci: obj.lci, hci: obj.hci };
    confidenceIndicators.push(confidenceIndicator);
    makeTooltipDisplay(obj, chartConfigObject);
  });

  // map codes to category names (sort order handled)
  xAxisCategoryDataCodes.forEach((code) => {
    const lku = lookup[xAxisType];
    if (lku[code].name) {
      const { name } = lku[code];
      if (xAxisCategoryNames.indexOf(name) < 0) { xAxisCategoryNames.push(name); }
    }
  });

  // map codes to legend columns. handle sort.
  const legendColumnSortedJsonData = sortedJsonData.sort((a, b) => { // sort data (legend column responses display by ascending sort number)
    const sortColA = a[legendColumn];
    const sortColB = b[legendColumn];
    if (lookup[legendType][sortColA].sort < lookup[legendType][sortColB].sort) { return -1; }
    if (lookup[legendType][sortColB].sort < lookup[legendType][sortColA].sort) { return 1; }
    return 0;
  });

  legendColumnSortedJsonData.forEach((object) => {
    let barDataValue = object.dv; // get data values
    if (barDataValue) {
      let arr = barDataValue.toString().split('');
      if (arr.indexOf('.') >= 0) { // check if num has a decimal
        barDataValue = Number(object.dv.toFixed(decimalPlaces));
        barDataValues.push(barDataValue);
      } else { // add decimal
        arr.push('.0');
        arr = arr.join('');
        barDataValue = Number(arr);
        barDataValues.push(barDataValue);
      }
    } else {
      barDataValue = 0;
      barDataValues.push(barDataValue);
    }

    const lku = lookup[legendType];
    const code = object[legendColumn];
    if (lku[code].name) {
      const { name } = lku[code];
      if (legendCategoryNames.indexOf(name) < 0) { // check array for existing str
        legendCategoryNames.push(name);
      }
    }
  });

  legendEntryCount = legendCategoryNames.length;

  function wrap(text, width) {
    text.each(function wrapText() {
      const text = d3.select(this);
      const words = text.text().split(/\s+/).reverse();
      let word;
      let line = [];
      let lineNumber = 0;
      const lineHeight = 1.1; // ems
      const y = text.attr('y');
      const dy = parseFloat(text.attr('dy'));
      let tspan = text.text(null).append('tspan').attr('x', 0).attr('y', y)
        .attr('dy', `${dy}em`)
        .style('text-anchor', () => {
          if (xAxisCategoryNames.length > 5) { return 'end'; }
          return 'middle';
        });
      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(' '));
          line = [word];
          tspan = text.append('tspan').attr('x', 0).attr('y', y).attr('dy', `${++lineNumber * lineHeight + dy}em`)
            .style('text-anchor', () => {
              if (xAxisCategoryNames.length > 5) { return 'end'; }
              return 'middle';
            })
            .text(word);
        }
      }
    });
  }

  // calculate chart container
  const { clientWidth } = d3.select(`#${chartDivId}`)._groups[0][0];

  // svg chart variables
  const margin = {
    top: 30, right: 0, bottom: 120, left: 60,
  };
  const width = clientWidth - margin.left - margin.right;
  const height = 300 - margin.top - margin.bottom;
  const totalWidth = width + margin.left + margin.right;
  const totalHeight = height + margin.top + margin.bottom;
  const chartTopBufferDataValue = 10; // verify this value with team
  const chartBottomBufferLegend = totalHeight - 30;
  const spaceFromTop = height + margin.top;
  const legendColorKeyWidth = 14;
  const legendColorKeyHeight = 14;

  // tool tip
  const tooltipDiv = d3.select(`#${chartDivId}`).append('div')
    .attr('class', 'tooltip')
    .style('opacity', 0);
  // scale
  const x = d3.scaleBand()
    .domain(xAxisCategoryNames)
    .range([0, width]); // total width
  const hciArray = confidenceIndicators.map(ind => ind.hci);
  const y = d3.scaleLinear()
    .domain([0, d3.max(hciArray) + chartTopBufferDataValue]) // set value scaling with buffer
    .range([height, 0]);
  // gridlines in y axis
  function makeYGridlines() {
    return d3.axisLeft(y);
  }

  function makeTrendChart() {
    const chart = d3.select(`#${chartDivId}`).append('svg').attr('class', 'chart'); // instantiate chart

    // 508 compliance
    chart.append('desc').html(chartDesc);

    // data
    let highestValue = d3.max(barDataValues);
    // console.log('before rounding:', highestValue);

    // round to nearest whole number
    // highestValue = Number(highestValue.toFixed());

    // console.log('after rounding:', highestValue);
    // round to nearest 5 (above its value)
    // while (highestValue % 5 > 0) {
    //   highestValue += 1;
    // }
    // console.log('after rounding up to nearest 5:', highestValue);

    const dataGroup = d3Nest.nest()
      .key(d => d[legendColumn])
      .entries(sortedJsonData); // sorts values by response

    for (let i = 0; i < dataGroup.length; i += 1) {
      dataGroup[i].values.sort((a, b) => {
        if (a.yr < b.yr) { return -1; }
        if (a.yr > b.yr) { return 1; }
        return 0;
      });
    } // sorts values by year

    function getTickValues(highestValue) {
      // renders 3-8 gridlines
      let interval;
      let gridlines = 1; // start with 0 gridline
      const array = [];
      // test for evenly divisible gridlines for: 7, 6, 5, 4, 3, 2
      // if no values are evenly divisible, then use 7 (totals 8 gridlines, including 0 gridline)
      if (highestValue % 7 === 0) {
        interval = highestValue / 7;
        gridlines += 7;
      } else if (highestValue % 6 === 0) {
        interval = highestValue / 6;
        gridlines += 6;
      } else if (highestValue % 5 === 0) {
        interval = highestValue / 5;
        gridlines += 5;
      } else if (highestValue % 4 === 0) {
        interval = highestValue / 4;
        gridlines += 4;
      } else if (highestValue % 3 === 0) {
        interval = highestValue / 3;
        gridlines += 3;
      } else if (highestValue % 2 === 0) {
        interval = highestValue / 2;
        gridlines += 2;
        // } else if (highestValue % 8 === 0) {
        //   interval = highestValue / 8;
        //   gridlines += 8;
        // } else if (highestValue % 9 === 0) {
        //   interval = highestValue / 9;
        //   gridlines += 9;
        // } else if (highestValue % 10 === 0) {
        //   interval = highestValue / 10;
        //   gridlines += 10;
        // } else if (highestValue % 11 === 0) {
        //   interval = highestValue / 11;
        //   gridlines += 11;
        // } else if (highestValue % 12 === 0) {
        //   interval = highestValue / 12;
        //   gridlines += 12;
        // } else if (highestValue % 13 === 0) {
        //   interval = highestValue / 13;
        //   gridlines += 13;
        // } else if (highestValue % 14 === 0) {
        //   interval = highestValue / 14;
        //   gridlines += 14;
        // } else if (highestValue % 15 === 0) {
        //   interval = highestValue / 15;
        //   gridlines += 15;
        // } else if (highestValue % 16 === 0) {
        //   interval = highestValue / 16;
        //   gridlines += 16;
        // } else if (highestValue % 17 === 0) {
        //   interval = highestValue / 17;
        //   gridlines += 17;
      } else {
        interval = highestValue / 7;
        gridlines += 7;
      }
      for (let i = 0; i < gridlines; i += 1) {
        // array[i] = Math.round(interval * i);
        array[i] = interval * i;
      }
      return array;
    }

    // scaling
    const radius = 5;
    const strokeWidth = 2;
    const x3 = d3.scaleLinear()
      .domain([d3.min(xAxisCategoryNames), d3.max(xAxisCategoryNames)])
      .range([0, width - 20]);
    const yMulti = d3.scaleLinear()
      // .domain([0, d3.max(barDataValues)])
      .domain([0, highestValue])
      .rangeRound([height, 0]);
    const colors = d3.scaleOrdinal(barColors)
      .domain(dataGroup.map(d => d.key));
    const makeLines = d3.line()
      .x((d) => {
        const column = d[xAxisColumn];
        const value = Number(lookup[xAxisType][column].name);
        return (margin.left + x3(value));
      })
      .y(d => margin.top + yMulti(d.dv));
    function makeYGridlinesMultiBar() { return d3.axisLeft(yMulti); }
    function makeXGridlines() { return d3.axisBottom(x3); }

    // legend variables
    const legendItemSpacingWidePanel = 4;
    const legendItemSpacingSmallViewport = 2;
    // y gridlines (inserted for visual layering. refactor later as a sorted element)
    chart.append('g')
      .attr('class', 'grid axis label')
      .style('font-size', '14px')
      .call(makeYGridlinesMultiBar()
        .tickValues(getTickValues(highestValue))
        .tickSize(-width + 10))
      .attr('transform', `translate(${margin.left - 10},${margin.top})`);
    // x gridlines
    chart.append('g')
      .attr('class', 'grid')
      .style('font-size', '14px')
      .call(makeXGridlines()
        .tickValues(xAxisCategoryNames)
        .tickFormat(d3.format('d'))
        .tickSize(-height - 10))
      .attr('transform', () => {
        const xAxisHeight = height + margin.top;
        return `translate(${margin.left},${xAxisHeight + 10})`;
      });
    const response = chart.selectAll('.response')
      .data(dataGroup)
      .enter().append('g')
      .attr('class', 'response');
    // lines
    response.append('path')
      .data(dataGroup)
      .attr('class', d => `pathline ${d.key}`)
      .attr('d', d => makeLines(d.values))
      .style('stroke', d => colors(d.key))
      .style('stroke-width', strokeWidth)
      .style('fill', 'none');
    // circles
    response.selectAll('circle')
      .data(d => d.values)
      .enter().append('circle')
      .attr('class', 'circle_data_display')
      .attr('r', (d) => {
        if (d.dv) {
          return radius;
        }
        return 0;
        // set radius if data value is null or undefined
      })
      .attr('cx', (d) => {
        if (d.dv) {
          const column = d[xAxisColumn];
          const value = Number(lookup[xAxisType][column].name);
          return (margin.left + x3(value));
        }
        return 0;
      })
      .attr('cy', (d) => {
        if (d.dv) {
          return margin.top + yMulti(d.dv);
        }
        return 0;
      })
      .on('mouseover', function mouseover(d) {
        // line and circle effects
        d3.select(`.${d[legendColumn]}`).style('stroke-width', strokeWidth * 1.65);
        d3.select(this).attr('r', radius * 1.75)
          .attr('class', 'shadow');
        // tooltip
        let display;
        function makesTooltipDisplay(d, xAxisColumn) {
          let hciNum;
          let lciNum;
          let valNum;
          const column = d[xAxisColumn];
          let wn = String(d.wn);
          if (wn.length > 3 && wn.length < 7) {
            wn = wn.split('').reverse().join('');
            wn = `${wn.substring(0, 3)},${wn.substring(3)}`;
            wn = wn.split('').reverse().join('');
          } else if (wn.length > 6 && wn.length < 10) {
            wn = wn.split('').reverse().join('');
            wn = `${wn.substring(0, 3)},${wn.substring(3, 6)},${wn.substring(6)}`;
            wn = wn.split('').reverse().join('');
          }
          // handle decimals
          if (d.hci >= 0 && d.hci != null) {
            let hciArr = d.hci.toString().split('');
            switch (hciArr.indexOf('.') >= 0) { // hci
              case true:
                hciArr = hciArr.join('');
                hciArr = Number(hciArr);
                hciNum = hciArr.toFixed(decimalPlaces);
                break;
              case false:
                hciArr = hciArr.join('');
                hciArr = Number(hciArr);
                hciNum = hciArr.toFixed(decimalPlaces);
                break;
              default:
                break;
            }
          }
          if (d.lci >= 0 && d.lci != null) {
            let lciArr = d.lci.toString().split('');
            switch (lciArr.indexOf('.') >= 0) { // lci
              case true:
                lciArr = lciArr.join('');
                lciArr = Number(lciArr);
                lciNum = lciArr.toFixed(decimalPlaces);
                break;
              case false:
                lciArr = lciArr.join('');
                lciArr = Number(lciArr);
                lciNum = lciArr.toFixed(decimalPlaces);
                break;
              default:
                break;
            }
          }
          if (d.dv >= 0 && d.dv != null) {
            let valArr = d.dv.toString().split('');
            switch (valArr.indexOf('.') >= 0) { // val
              case true:
                valArr = valArr.join('');
                valArr = Number(valArr);
                valNum = valArr.toFixed(decimalPlaces);
                break;
              case false:
                valArr = valArr.join('');
                valArr = Number(valArr);
                valNum = valArr.toFixed(decimalPlaces);
                break;
              default:
                break;
            }
          }
          display = {
            title: lookup[xAxisType][column].name,
            titleLegendColumn: lookup[legendType][d[legendColumn]].name,
            dv: valNum || d.dv,
            lci: lciNum || d.lci,
            hci: hciNum || d.hci,
            sampleSizeLabel: chartConfigObject.sampleSizeLabel,
            wn,
          };
        }
        makesTooltipDisplay(d, xAxisColumn);
        tooltipDiv.transition()
          .duration(200)
          .style('opacity', 0.9);
        tooltipDiv.html(`\n<strong>${display.title}</strong>\n<br /><strong>${display.titleLegendColumn}</strong>\n<br /><strong>${display.dv}${dataValueSuffix}</strong>\n<br />95% CI (${display.lci}-${display.hci})\n<br />${display.sampleSizeLabel}:${display.wn}\n`)
          .style('left', () => {
            let xCoordinate;
            const isChrome = !!window.chrome && !!window.chrome.webstore;
            const isFirefox = typeof InstallTrigger !== 'undefined';
            // detect Chrome offsetX method)
            if (isChrome) {
              if (event.offsetX >= event.target.parentNode.parentNode.clientWidth - 50) {
                xCoordinate = event.offsetX - 225;
                return `${xCoordinate}px`;
              }
              xCoordinate = event.offsetX + 25;
              return `${xCoordinate}px`;
            }
            // detect Firefox (layerX method)
            if (isFirefox) {
              const ffWidth = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.clientWidth;
              if (event.layerX >= ffWidth - 50) {
                xCoordinate = event.layerX - 225;
                return `${xCoordinate}px`;
              }
              xCoordinate = event.layerX + 25;
              return `${xCoordinate}px`;
            }
            // Other browsers, including Internet Explorer (x method), change to layerX to fix alignment
            if (event.x >= event.target.parentNode.parentNode.clientWidth - 50) {
              xCoordinate = event.layerX - 225;
              return `${xCoordinate}px`;
            }
            xCoordinate = event.x + 25;
            return `${xCoordinate}px`;
          })
          .style('top', () => {
            const tooltipHeight = 160;
            const yCoordinate = event.pageY - event.clientY - window.pageYOffset - tooltipHeight + 200;
            return `${yCoordinate}px`;
          });
      })
      .on('mouseout', (d) => {
        // line and circle effects
        d3.select(`.${d[legendColumn]}`).style('stroke-width', strokeWidth);
        d3.selectAll('circle').filter('.shadow')
          .attr('r', (d) => {
            if (d.dv) {
              return radius;
            }
            return 0;
            // set radius if data value is null or undefined
          })
          .attr('class', '');
        // tooltip
        tooltipDiv.transition()
          .duration(500)
          .style('opacity', 0);
      });
    response.data(dataGroup)
      .style('fill', d => colors(d.key));
    // axes labels
    let yAxisMidpoint = (height + margin.top) / 2;
    yAxisMidpoint += margin.top / 2;
    const paddingLeft = 14;
    chart.append('text')
      .attr('class', 'label')
      .style('font-size', '14px')
      .text(yAxisTitle)
      .attr('transform', `translate(${paddingLeft}, ${yAxisMidpoint})rotate(-90)`)
      .attr('text-anchor', 'middle');

    // // legend
    const legend = chart.append('g') // create & position legend area
      .attr('class', 'legend')
      .attr('transform', `translate(${margin.left}, ${chartBottomBufferLegend})`);
    legend.append('text')
      .attr('class', 'legend_title')
      .attr('transform', () => `translate(${-5},${0})`)
      .text(legendTitle);
    const legendGrouping = legend.selectAll('g'); // groupings do not exist yet
    // legend - color bars
    legendGrouping.data(legendCategoryNames) // count data
      .enter() // run methods once per data count
      .append('g') // produces new groupings
      .append('line')
      .attr('x1', (d, i) => {
        if (totalWidth > 715) {
          // first line
          if (i < legendItemSpacingWidePanel) {
            return `${totalWidth / legendItemSpacingWidePanel * i - 10}`;
          } // second line
          const j = i - legendItemSpacingWidePanel;
          return `${totalWidth / legendItemSpacingWidePanel * j - 10}`;
        }
        // first line
        if (i < legendItemSpacingSmallViewport) {
          return `${totalWidth / legendItemSpacingSmallViewport * i - 10}`;
        } else if (i >= legendItemSpacingSmallViewport && i < legendItemSpacingSmallViewport * 2) { // second line
          const j = i - legendItemSpacingSmallViewport;
          return `${totalWidth / legendItemSpacingSmallViewport * j - 10}`;
        }
        const k = i - legendItemSpacingSmallViewport * 2; // third line
        return `${totalWidth / legendItemSpacingSmallViewport * k - 10}`;
      })
      .attr('y1', (d, i) => {
        if (totalWidth > 715) {
          // first line
          if (i < legendItemSpacingWidePanel) {
            return `${15}`;
          } // second line
          return `${45}`;
        }
        // first line
        if (i < legendItemSpacingSmallViewport) {
          return `${15}`;
        } else if (i >= legendItemSpacingSmallViewport && i < legendItemSpacingSmallViewport * 2) { // second line
          return `${45}`;
        }
        return `${75}`;
      })
      .attr('x2', (d, i) => {
        if (totalWidth > 715) {
          // first line
          if (i < legendItemSpacingWidePanel) {
            return `${totalWidth / legendItemSpacingWidePanel * i + 10}`;
          } // second line
          const j = i - legendItemSpacingWidePanel;
          return `${totalWidth / legendItemSpacingWidePanel * j + 10}`;
        }
        // first line
        if (i < legendItemSpacingSmallViewport) {
          return `${totalWidth / legendItemSpacingSmallViewport * i + 10}`;
        } else if (i >= legendItemSpacingSmallViewport && i < legendItemSpacingSmallViewport * 2) { // second line
          const j = i - legendItemSpacingSmallViewport;
          return `${totalWidth / legendItemSpacingSmallViewport * j + 10}`;
        }
        const k = i - legendItemSpacingSmallViewport * 2; // third line
        return `${totalWidth / legendItemSpacingSmallViewport * k + 10}`;
      })
      .attr('y2', (d, i) => {
        if (totalWidth > 715) {
          // first line
          if (i < legendItemSpacingWidePanel) {
            return `${15}`;
          } // second line
          return `${45}`;
        }
        // first line
        if (i < legendItemSpacingSmallViewport) {
          return `${15}`;
        } else if (i >= legendItemSpacingSmallViewport && i < legendItemSpacingSmallViewport * 2) { // second line
          return `${45}`;
        }
        return `${75}`;
      })
      .attr('stroke-width', 2.8)
      .attr('stroke', (d, i) => barColors[i]);
    legendGrouping.data(legendCategoryNames)
      .enter()
      .append('g')
      .append('circle')
      .attr('class', 'circle_legend_display')
      .attr('r', 4.9)
      .attr('transform', (d, i) => {
        if (totalWidth > 715) {
          // first line
          if (i < legendItemSpacingWidePanel) {
            return `translate(${totalWidth / legendItemSpacingWidePanel * i}, ${15})`;
          } // second line
          const j = i - legendItemSpacingWidePanel;
          return `translate(${totalWidth / legendItemSpacingWidePanel * j}, ${45})`;
        }
        // first line
        if (i < legendItemSpacingSmallViewport) {
          return `translate(${totalWidth / legendItemSpacingSmallViewport * i}, ${15})`;
        } else if (i >= legendItemSpacingSmallViewport && i < legendItemSpacingSmallViewport * 2) { // second line
          const j = i - legendItemSpacingSmallViewport;
          return `translate(${totalWidth / legendItemSpacingSmallViewport * j}, ${45})`;
        }
        const j = i - legendItemSpacingSmallViewport * 2; // third line
        return `translate(${totalWidth / legendItemSpacingSmallViewport * j}, ${75})`;
      })
      .style('fill', (d, i) => barColors[i]);
    legendGrouping
      .data(legendCategoryNames)
      .enter()
      .append('text')
      .text(d => d)
      .attr('transform', (d, i) => {
        if (totalWidth > 715) {
          // first line
          if (i < legendItemSpacingWidePanel) {
            return `translate(${totalWidth / legendItemSpacingWidePanel * i + 15}, ${20})`;
          } // second line
          const j = i - legendItemSpacingWidePanel;
          return `translate(${totalWidth / legendItemSpacingWidePanel * j + 15}, ${50})`;
        }
        // first line
        if (i < legendItemSpacingSmallViewport) {
          return `translate(${totalWidth / legendItemSpacingSmallViewport * i + 15}, ${20})`;
        } else if (i >= legendItemSpacingSmallViewport && i < legendItemSpacingSmallViewport * 2) { // second line
          const j = i - legendItemSpacingSmallViewport;
          return `translate(${totalWidth / legendItemSpacingSmallViewport * j + 15}, ${50})`;
        }
        const j = i - legendItemSpacingSmallViewport * 2; // third line
        return `translate(${totalWidth / legendItemSpacingSmallViewport * j + 15}, ${80})`;
      });
  }

  function makeChartSingleBar() {
    const chart = d3.select(`#${chartDivId}`).append('svg').attr('class', 'chart'); // instantiate chart

    const highestValue = d3.max(hciArray) + chartTopBufferDataValue - 5;
    function getTickValues(highestValue) {
      // renders 3-8 gridlines
      let interval;
      let gridlines = 1; // start with 0 gridline
      const array = [];
      highestValue = Math.round(highestValue);
      highestValue = Math.ceil(highestValue / 5) * 5;

      // test for evenly divisible gridlines for: 7, 6, 5, 4, 3, 2
      // if no values are evenly divisible, then use 7 (totals 8 gridlines, including 0 gridline)
      if (highestValue % 7 === 0) {
        interval = highestValue / 7;
        gridlines += 7;
      } else if (highestValue % 6 === 0) {
        interval = highestValue / 6;
        gridlines += 6;
      } else if (highestValue % 5 === 0) {
        interval = highestValue / 5;
        gridlines += 5;
      } else if (highestValue % 4 === 0) {
        interval = highestValue / 4;
        gridlines += 4;
      } else if (highestValue % 3 === 0) {
        interval = highestValue / 3;
        gridlines += 3;
      } else if (highestValue % 2 === 0) {
        interval = highestValue / 2;
        gridlines += 2;
      } else {
        interval = highestValue / 7;
        gridlines += 7;
      }

      for (let i = 0; i < gridlines; i += 1) {
        array[i] = Math.round(interval * i);
      }
      return array;
    }

    chart.append('desc').html(chartDesc); // 508 compliance
    let bar = chart.selectAll('g'); // create bar grouping
    chart.append('g') // add the Y gridlines
      .attr('class', 'grid axis label')
      .call(makeYGridlines()
        .tickValues(getTickValues(highestValue))
        .tickSize(0 - width) // full graph width
      )
      .attr('transform', `translate(${margin.left - 5},${margin.top})`);
    bar = bar.data(xAxisCategoryNames)
      .enter()
      .append('g')
      .attr('transform', (d, i) => {
        const padding30Percent = x.bandwidth() * 0.33;
        const spaceLeft = margin.left + x.bandwidth() * i + padding30Percent / 2;
        return `translate(${spaceLeft}, ${margin.top})`;
      });
    // append *
    bar.append('text')
      .data(barDataValues)
      .text('*')
      .style('font-size', '27px')
      .attr('y', d => y(d) + 4)
      .attr('x', (d, i) => {
        const padding30Percent = x.bandwidth() * 0.33;
        return x.bandwidth() / 2 - padding30Percent / 2;
      })
      .style('opacity', d => {
        if (d === 0) { return '0.8'; } else { return '0'; }
      });

    // append bars
    bar.append('rect')
      .data(barDataValues)
      .attr('y', d => y(d)) // y coordinate
      .attr('height', d => height - y(d)) // height
      .attr('width', () => {
        const padding30Percent = x.bandwidth() * 0.33;
        return x.bandwidth() - padding30Percent;
      })
      .style('fill', barColors[0]) // hard-coded first color in array
      .style('opacity', '0.8')
      .data(tooltipDisplay)
      .on('mouseover', function mouseover(event, d, i) {
        d3.select(this).style('opacity', '0.7');
        tooltipDiv.transition()
          .duration(200)
          .style('opacity', 0.9);
        tooltipDiv.html(`\n<strong>${d.title}</strong>\n<br /><strong>${d.dv}${d.dataValueSuffix}</strong>\n<br />95% CI (${d.lci} - ${d.hci})\n<br />${d.sampleSizeLabel}:${d.wn}\n`)
          .style('left', () => {
            let xCoordinate;
            // const tooltipWidth = tooltipDiv._groups[0][0].clientWidth; // previously 200
            const tooltipWidth = 200;
            const isChrome = !!window.chrome && !!window.chrome.webstore;
            const isFirefox = typeof InstallTrigger !== 'undefined';
            // detect Chrome offsetX method)
            if (isChrome) {
              const chromeWidth = event.target.parentNode.parentNode.parentNode.clientWidth - 70;
              if (event.offsetX >= chromeWidth) {
                xCoordinate = event.offsetX - tooltipWidth / 1.1;
                return `${xCoordinate}px`;
              }
              xCoordinate = event.offsetX - tooltipWidth / 2;
              return `${xCoordinate}px`;
            }
            // detect Firefox (layerX method)
            if (isFirefox) {
              if (event.layerX >= event.target.parentNode.parentNode.parentNode.clientWidth - 70) {
                xCoordinate = event.layerX - tooltipWidth / 1.1;
                return `${xCoordinate}px`;
              }
              xCoordinate = event.layerX - tooltipWidth / 2;
              return `${xCoordinate}px`;
            }
            // Other browsers, including Internet Explorer (x method), change to layerX to fix alignment
            if (event.x >= event.target.parentNode.parentNode.parentNode.clientWidth - 70) {
              xCoordinate = event.layerX - tooltipWidth / 1.1;
              return `${xCoordinate}px`;
            }
            xCoordinate = event.x - tooltipWidth / 2;
            return `${xCoordinate}px`;
          })
          .style('top', () => {
            const tooltipHeight = tooltipDiv._groups[0][0].clientHeight;
            const yCoordinate = event.pageY - event.clientY - window.pageYOffset - tooltipHeight + 150;
            return `${yCoordinate}px`;
          });
      })
      .on('mouseout', () => {
        d3.selectAll('rect').style('opacity', '0.8');
        tooltipDiv.transition()
          .duration(500)
          .style('opacity', 0);
      });
    // confidence indicator
    bar.append('line')
      .attr('class', 'confidence_indicator')
      .data(confidenceIndicators)
      .attr('x1', (d) => {
        if (!d.hci || !d.lci) { return 0; }
        const padding30Percent = x.bandwidth() / 3;
        return padding30Percent;
      })
      .attr('y1', (d) => {
        if (!d.lci) { return 0; }
        return y(d.lci);
      })
      .attr('x2', (d) => {
        if (!d.hci || !d.lci) { return 0; }
        return x.bandwidth() / 3;
      })
      .attr('y2', (d) => {
        if (!d.hci) { return 0; }
        return y(d.hci);
      });
    // confidence indicator linecaps
    const linecapHalfWidth = x.bandwidth() / 8; // calc ci line caps
    bar.append('line')
      .attr('class', 'linecap_top')
      .data(confidenceIndicators)
      .attr('x1', (d) => {
        if (!d.hci) { return 0; }
        return x.bandwidth() / 3 - linecapHalfWidth;
      })
      .attr('y1', (d) => {
        if (!d.hci) {
          return 0;
        }
        return y(d.hci);
      })
      .attr('x2', (d) => {
        if (!d.hci) { return 0; }
        return x.bandwidth() / 3 + linecapHalfWidth;
      })
      .attr('y2', (d) => {
        if (!d.hci) {
          return 0;
        }
        return y(d.hci);
      });
    bar.append('line')
      .attr('class', 'linecap_top')
      .data(confidenceIndicators)
      .attr('x1', (d) => {
        if (!d.hci) { return 0; }
        return x.bandwidth() / 3 - linecapHalfWidth;
      })
      .attr('y1', (d) => {
        if (!d.lci) { return 0; }
        return y(d.lci);
      })
      .attr('x2', (d) => {
        if (!d.hci || !d.lci) { return 0; }
        return x.bandwidth() / 3 + linecapHalfWidth;
      })
      .attr('y2', (d) => {
        if (!d.lci) { return 0; }
        return y(d.lci);
      });
    // axes labels
    const yAxisMidpoint = (height + margin.top) / 2 + margin.top / 2;
    const paddingLeft = 14;
    chart.append('text')
      .attr('class', 'label')
      .text(yAxisTitle)
      .attr('transform', `translate(${paddingLeft}, ${yAxisMidpoint})rotate(-90)`)
      .attr('text-anchor', 'middle');
    // axes
    chart.append('g')
      .attr('class', 'axis')
      .attr('transform', `translate(${margin.left}, ${spaceFromTop})`)
      .call(d3.axisBottom(x))
      .selectAll('text')
      .call(wrap, xAxisLabelMaxWidth)
      .style('text-anchor', () => {
        if (xAxisCategoryNames.length > 5) { return 'end'; }
        return 'middle';
      })
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', () => {
        if (xAxisCategoryNames.length > 5) { return 'rotate(-45)'; }
        return 'rotate(0)';
      });

    // // legend
    var newMultiBarLegend = new Legend($(`#${chartDivId}`), legendTitle, legendCategoryNames, barColors);
    newMultiBarLegend.makeLegend();

    // TODO: Make the below into a Object Constructor
    // let barChart = myLegend.targetChart;
    // let legend = '<section class="new-legend">';
    // let lengendIntro = '<h5 class="legend-title">' + myLegend.legendTitle + '</h5>';
    // let legendList = '<ul class="legend-list">';
    // let legendListStacked = '<ul class="legend-list stacked">';
    // let legendItem = '<li class="legend-item">';
    // let dataset = myLegend.legendCategories;
    // legend += lengendIntro;
    // if (dataset.length <= 4) {
    //   legend += legendList;
    // } else {
    //   legend += legendListStacked;
    // }
    // for (let i =0; i < dataset.length; i++) {
    //   legend += legendItem;
    //   legend += '<i class="legend-icon" style="background-color:' + barColors[i] + '"></i>';
    //   legend += '<span class="legend-label">' + dataset[i] + '<span>';
    //   legend += '</li>';
    // }
    // legend += '</ul>';
    // legend += '</section>';
    // barChart.append(legend);

    // Old legend
    // const legend = chart.append('g') // create & position legend area
    //   .attr('class', 'legend')
    //   .attr('transform', `translate(${margin.left}, ${chartBottomBufferLegend})`);
    // legend.append('text')
    //   .attr('class', 'legend_title')
    //   .attr('transform', () => `translate(${0},${0})`)
    //   .text(legendTitle);
    // const legendEntry = legend.selectAll('g') // groupings do not exist yet
    //   .data(legendCategoryNames) // count data
    //   .enter() // run methods once per data count
    //   .append('g') // produces new groupings
    //   .attr('height', legendColorKeyHeight);
    // legendEntry.append('rect')
    //   .attr('width', legendColorKeyWidth)
    //   .attr('height', legendColorKeyHeight)
    //   .attr('transform', (d, i) => `translate(${totalWidth / 5 * i}, ${15})`)
    //   .style('fill', (d, i) => barColors[i]);
    // legendEntry.append('text')
    //   .text(d => d)
    //   .attr('transform', (d, i) => {
    //     const paddingLeft = legendColorKeyWidth * 2;
    //     return `translate(${totalWidth / 5 * i + paddingLeft}, ${25})`;
    //   });
  }

  function makeChartMultiBar() {
    let chart = d3.select(`#${chartDivId}`).append('svg').attr('class', 'chart'); // instantiate chart
    chart.append('desc').html(chartDesc); // 508 compliance

    // Lessen height of the chart
    // changes the height
    let chartCanvas = d3.select(`#${chartDivId}` + ' canvas');
    chartCanvas += chartCanvas.attr('height', '300');

    const x0 = d3.scaleBand()
      .domain(xAxisCategoryNames)
      .rangeRound([0, width])
      .paddingInner(0.3)
      .paddingOuter(0.17)
      .align(0.45);

    const x1 = d3.scaleBand()
      .domain(legendCategoryNames)
      .range([0, x0.bandwidth()])
      .paddingOuter(0)
      .paddingInner(0);

    const hciArray = confidenceIndicators.map(ind => ind.hci);

    const yMulti = d3.scaleLinear()
      .domain([0, d3.max(hciArray) + chartTopBufferDataValue])
      .rangeRound([height, 0]);

    function makeYGridlinesMulti() { return d3.axisLeft(yMulti); }
    function makeXGridlines() { return d3.axisBottom(x0); }

    const highestValue = d3.max(hciArray) + chartTopBufferDataValue;
    function getTickValues(highestValue) {
      // renders 3-8 gridlines
      let interval;
      let gridlines = 1; // start with 0 gridline
      const array = [];
      highestValue = Math.round(highestValue);
      highestValue = Math.ceil(highestValue / 5) * 5;

      // test for evenly divisible gridlines for: 7, 6, 5, 4, 3, 2
      // if no values are evenly divisible, then use 7 (totals 8 gridlines, including 0 gridline)
      if (highestValue % 7 === 0) {
        interval = highestValue / 7;
        gridlines += 7;
      } else if (highestValue % 6 === 0) {
        interval = highestValue / 6;
        gridlines += 6;
      } else if (highestValue % 5 === 0) {
        interval = highestValue / 5;
        gridlines += 5;
      } else if (highestValue % 4 === 0) {
        interval = highestValue / 4;
        gridlines += 4;
      } else if (highestValue % 3 === 0) {
        interval = highestValue / 3;
        gridlines += 3;
      } else if (highestValue % 2 === 0) {
        interval = highestValue / 2;
        gridlines += 2;
      } else {
        interval = highestValue / 7;
        gridlines += 7;
      }

      for (let i = 0; i < gridlines; i += 1) {
        array[i] = Math.round(interval * i);
      }
      return array;
    }

    // data
    const dataMatrix = []; // maps bar data vals
    let dataMatrixMissingData = []; // filters for empty bar data vals
    const ciMatrix = []; // maps CI intervals
    const linecapHalfWidth = x1.bandwidth() / 8; // calc ci line caps
    function createDataMatrix() {
      let i;
      for (i = 0; i < xAxisCategoryDataCodes.length; i += 1) {
        // loop through each response category. filter for json data matches and return
        const filteredJSON = sortedJsonData.filter((object, index, array) => object[xAxisColumn] === xAxisCategoryDataCodes[i]);
        let hciNum;
        let lciNum;
        let valNum;
        // create key objects
        const keysFromFilteredJSON = filteredJSON.map((object) => {
          let valArr;
          // handle decimals
          if (object.hci >= 0 && object.hci != null) {
            let hciArr = object.hci.toString().split('');
            switch (hciArr.indexOf('.') >= 0) { // hci
              case true:
                hciArr = hciArr.join('');
                hciNum = Number(hciArr);
                break;
              case false:
                hciArr = hciArr.join('');
                hciArr = Number(hciArr);
                hciNum = hciArr.toFixed(decimalPlaces);
                break;
              default:
                break;
            }
          }
          if (object.lci >= 0 && object.lci != null) {
            let lciArr = object.lci.toString().split('');
            switch (lciArr.indexOf('.') >= 0) { // lci
              case true:
                lciArr = lciArr.join('');
                lciNum = Number(lciArr);
                break;
              case false:
                lciArr = lciArr.join('');
                lciArr = Number(lciArr);
                lciNum = lciArr.toFixed(decimalPlaces);
                break;
              default:
                break;
            }
          }
          if (!object.dv) {
            valNum = 0;
          } else {
            valArr = object.dv.toString().split('');
            switch (valArr.indexOf('.') >= 0) { // val
              case true:
                valArr = valArr.join('');
                valNum = Number(valArr);
                break;
              case false:
                valArr = valArr.join('');
                valArr = Number(valArr);
                valNum = valArr.toFixed(decimalPlaces);
                break;
              default:
                break;
            }
          }
          return {
            // keys render bars
            key: object[xAxisColumn],
            val: valNum || object.dv,
            // keys render tooltip
            title: object[xAxisColumn],
            titleLegendColumn: object[legendColumn],
            lci: lciNum || object.lci,
            hci: hciNum || object.hci,
            wn: object.wn,
          };
        });
        dataMatrix.push(keysFromFilteredJSON);
      }
    }
    createDataMatrix(xAxisCategoryNames, xAxisCategoryDataCodes, xAxisColumn, xAxisType, sortedJsonData);

    function createDataMatrixMissingData(dataMatrix) { // dataMatrix is an array of arrays
      for (var i = 0; i < dataMatrix.length; i++) { // handle each array
        const filteredArray = dataMatrix[i].filter(function (d) {
          return !d.val;
        })
        dataMatrixMissingData.push(filteredArray);
      }
    }
    createDataMatrixMissingData(dataMatrix);

    function createCIMatrix() {
      let i;
      for (i = 0; i < xAxisCategoryDataCodes.length; i += 1) {
        // loop through each response category. filter for json data matches and return
        const filteredJSON = sortedJsonData.filter((object, index, array) => object[xAxisColumn] === xAxisCategoryDataCodes[i]);
        // create key objects
        const keysFromFilteredJSON = filteredJSON.map(object => ({ lci: object.lci, hci: object.hci }));
        ciMatrix.push(keysFromFilteredJSON);
      }
    }
    createCIMatrix();

    // append first grouping (container for y gridlines, response groupings, axis, legend, etc)
    chart = chart.append('g');
    // resp grouping
    let responseGrouping = chart.selectAll('g');
    // y gridlines (inserted for visual layering. refactor later as a sorted element)
    chart.append('g')
      .attr('class', 'grid axis label')
      .call(makeYGridlinesMulti()
        .tickValues(getTickValues(highestValue))
        .tickSize(0 - width) // full graph width
      )
      .attr('transform', `translate(${margin.left - 5},${margin.top})`);
    const xAxisTicks = chart.append('g')
      .attr('class', 'grid')
      .call(makeXGridlines()
        .tickValues(xAxisCategoryNames)
        .tickSize(-10))
      .attr('transform', () => {
        const xAxisHeight = height + margin.top;
        return `translate(${margin.left - x.bandwidth() / 2},${xAxisHeight + 10})`;
      });
    xAxisTicks.selectAll('text').remove();
    // ...resp grouping cont'd
    responseGrouping = responseGrouping.data(xAxisCategoryNames)
      .enter().append('g')
      .attr('class', 'response_grouping')
      .attr('transform', d => `translate(${x0(d)}, ${margin.top})`);
    // append *
    responseGrouping
      .data(dataMatrix)
      .selectAll('text') // container
      .data(d => d)
      .enter()
      .append('text')
      .text('*')
      .style('opacity', function (d) {
        if (d.val) { return '0'; } else { return '0.99'; }
      })
      .style('font-size', '27px')
      .attr('x', (d, i) => {
        return margin.left + x1.bandwidth() * i + x1.bandwidth() * 0.5 - 5.25;
      })
      .attr('y', (d) => {
        return yMulti(0) + 6;
      });
    // append bars
    responseGrouping
      .data(dataMatrix) // set matrix data
      .selectAll('rect') // container
      .data(d => d) // process arrays
      .enter()
      .append('rect') // render matrix into grouped bars
      .attr('class', 'bar')
      .attr('x', (d, i) => {
        if (d.val) { return margin.left + x1.bandwidth() * 0.1 + x1.bandwidth() * i; } // accommodates 80% bars
        return 0;
      })
      .attr('y', (d) => {
        if (d.val) {
          return yMulti(d.val);
        } // checks for missing values
        return yMulti(0);
      })
      .attr('width', () => x1.bandwidth() * 0.80)
      .attr('height', (d) => {
        if (d.val) { return height - yMulti(d.val); }
        return 0;
      })
      .attr('fill', (d, i) => barColors[i])
      .style('opacity', '0.8')
      .on('mouseover', function mouseover(event, d, i) {
        d3.select(this).style('opacity', '0.7');
        let display;
        function makeTooltipDisplay(d) {
          let wn = String(d.wn);
          if (wn.length > 3 && wn.length < 7) {
            wn = wn.split('').reverse().join('');
            wn = `${wn.substring(0, 3)},${wn.substring(3)}`;
            wn = wn.split('').reverse().join('');
          } else if (wn.length > 6 && wn.length < 10) {
            wn = wn.split('').reverse().join('');
            wn = `${wn.substring(0, 3)},${wn.substring(3, 6)},${wn.substring(6)}`;
            wn = wn.split('').reverse().join('');
          }
          display = {
            title: lookup[xAxisType][d.title].name,
            titleLegendColumn: lookup[legendType][d.titleLegendColumn].name,
            dv: d.val,
            lci: d.lci,
            hci: d.hci,
            sampleSizeLabel: chartConfigObject.sampleSizeLabel,
            wn,
          };
        }
        makeTooltipDisplay(d, xAxisColumn);

        tooltipDiv.transition()
          .duration(200)
          .style('opacity', 0.9);

        tooltipDiv.html(`\n<strong>${display.title}</strong>\n<br /><strong>${display.titleLegendColumn}</strong>\n<br /><strong>${display.dv}${dataValueSuffix}</strong>\n<br />95% CI (${display.lci}-${display.hci})\n<br />${display.sampleSizeLabel}:${display.wn}\n`)
          .style('left', () => {
            let xCoordinate;
            // const tooltipWidth = tooltipDiv._groups[0][0].clientWidth;
            const tooltipWidth = 200;
            const isChrome = !!window.chrome && !!window.chrome.webstore;       
            const isFirefox = typeof InstallTrigger !== 'undefined';
            // detect Chrome offsetX method)         
            if (isChrome) {
              if (event.offsetX >= event.target.parentNode.parentNode.parentNode.clientWidth - 70) {
                xCoordinate = event.offsetX - tooltipWidth / 1.1;
                return `${xCoordinate}px`;
              }
              xCoordinate = event.offsetX - tooltipWidth / 2;
              return `${xCoordinate}px`;
            }
            // detect Firefox (layerX method)
            if (isFirefox) {
              if (event.layerX >= event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.clientWidth - 120) {
                xCoordinate = event.layerX - tooltipWidth / 1.1;
                return `${xCoordinate}px`;
              }
              xCoordinate = event.layerX - tooltipWidth / 2;
              return `${xCoordinate}px`;
            }
            // Other browsers, including Internet Explorer (x method), change to layerX to fix alignment
            if (event.x >= event.target.parentNode.parentNode.parentNode.clientWidth - 70) {
              xCoordinate = event.layerX - tooltipWidth / 1.1;
              return `${xCoordinate}px`;
            }
            xCoordinate = event.x - tooltipWidth / 2;
            return `${xCoordinate}px`;
          })
          .style('top', () => {
            const tooltipHeight = tooltipDiv._groups[0][0].clientHeight;
            const yCoordinate = event.pageY - event.clientY - window.pageYOffset - tooltipHeight + 150;
            return `${yCoordinate}px`;
          });
      })
      .on('mouseout', () => {
        d3.selectAll('rect').style('opacity', '0.8');
        tooltipDiv.transition()
          .duration(500)
          .style('opacity', 0);
      });
    // confidence intervals
    const ciIntervals = responseGrouping.data(ciMatrix).append('g'); // create new grouping
    ciIntervals.selectAll('line')
      .data(d => d)
      .enter().append('line')
      .attr('class', 'confidence_indicator')
      .attr('x1', (d, i) => {
        if (!d.lci) { return 0; }
        return margin.left + x1.bandwidth() / 2 + x1.bandwidth() * i;
      })
      .attr('y1', (d) => {
        if (!d.lci) { return yMulti(0); }
        return yMulti(d.lci);
      })
      .attr('x2', (d, i) => {
        if (!d.lci) { return 0; }
        return margin.left + x1.bandwidth() / 2 + x1.bandwidth() * i;
      })
      .attr('y2', (d) => {
        if (!d.hci) { return yMulti(0); }
        return yMulti(d.hci);
      });
    const ciIntervalCapsTop = ciIntervals.data(ciMatrix).append('g');
    ciIntervalCapsTop.selectAll('line')
      .data((d, i) => d)
      .enter().append('line')
      .attr('class', 'linecap_top')
      .attr('x1', (d, i) => {
        if (!d.hci) { return 0; }
        return margin.left + x1.bandwidth() * i + x1.bandwidth() / 2 - linecapHalfWidth;
      })
      .attr('y1', (d) => {
        if (d.hci) { return yMulti(d.hci); }
        return 0;
      })
      .attr('x2', (d, i) => {
        if (!d.hci) { return 0; }
        return margin.left + x1.bandwidth() * i + x1.bandwidth() / 2 + linecapHalfWidth;
      })
      .attr('y2', (d) => {
        if (d.hci) { return yMulti(d.hci); }
        return 0;
      });
    const ciIntervalCapsBottom = ciIntervals.data(ciMatrix).append('g');
    ciIntervalCapsBottom
      .selectAll('line')
      .data(d => d)
      .enter().append('line')
      .attr('class', 'linecap_bottom')
      .attr('x1', (d, i) => {
        if (!d.hci) { return 0; }
        return margin.left + x1.bandwidth() * i + x1.bandwidth() / 2 - linecapHalfWidth;
      })
      .attr('y1', (d) => {
        if (d.lci) { return yMulti(d.lci); }
        return 0;
      })
      .attr('x2', (d, i) => {
        if (!d.hci) { return 0; }
        return margin.left + x1.bandwidth() * i + x1.bandwidth() / 2 + linecapHalfWidth;
      })
      .attr('y2', (d) => {
        if (d.lci) { return yMulti(d.lci); }
        return 0;
      });
    // axes labels
    const yAxisMidpoint = (height + margin.top) / 2 + margin.top / 2;
    const paddingLeft = 14;
    chart.append('text')
      .attr('class', 'label')
      .text(yAxisTitle)
      .attr('transform', `translate(${paddingLeft}, ${yAxisMidpoint})rotate(-90)`)
      .attr('text-anchor', 'middle');
    chart.append('g')
      .attr('class', 'axis')
      .attr('transform', `translate(${margin.left}, ${spaceFromTop})`) // response label alignment
      .call(d3.axisBottom(x))
      .selectAll('text')
      .call(wrap, xAxisLabelMaxWidth)
      .style('text-anchor', () => {
        if (xAxisCategoryNames.length > 5) { return 'end'; }
        return 'middle';
      })
      .attr('width', '50px')
      .attr('dx', '-.8em')
      .attr('dy', '.15em')
      .attr('transform', () => {
        if (xAxisCategoryNames.length > 5) { return 'rotate(-45)'; }
        return 'rotate(0)';
      });

    // // legend
    var newSingleBarLegend = new Legend($(`#${chartDivId}`), legendTitle, legendCategoryNames, barColors);
    newSingleBarLegend.makeLegend();

    // TODO: Make the below into a Object Constructor
    // let barChart = myLegend.targetChart;
    // let legend = '<section class="new-legend">';
    // let lengendIntro = '<h5 class="legend-title">' + myLegend.legendTitle + '</h5>';
    // let legendList = '<ul class="legend-list">';
    // let legendListStacked = '<ul class="legend-list stacked">';
    // let legendItem = '<li class="legend-item">';
    // let dataset = myLegend.legendCategories;
    // legend += lengendIntro;
    // if (dataset.length <= 4) {
    //   legend += legendList;
    // } else {
    //   legend += legendListStacked;
    // }
    // for (let i =0; i < dataset.length; i++) {
    //   legend += legendItem;
    //   legend += '<i class="legend-icon" style="background-color:' + barColors[i] + '"></i>';
    //   legend += '<span class="legend-label">' + dataset[i] + '<span>';
    //   legend += '</li>';
    // }
    // legend += '</ul>';
    // legend += '</section>';
    // barChart.append(legend);

    // Old Legend
    // const legendItemTotalWidth = 210;
    // const legendWrappedItems = [];
    // const legend = chart.append('g') // create & position legend area
    //   .attr('class', 'legend')
    //   .attr('transform', `translate( ${margin.left}, ${chartBottomBufferLegend})`);
    // legend.append('text')
    //   .attr('class', 'legend_title')
    //   .attr('transform', () => `translate(${0},${0})`)
    //   .text(legendTitle);
    // const legendGrouping = legend.selectAll('g'); // groupings do not exist yet
    // legendGrouping.data(legendCategoryNames) // count data
    //   .enter() // run methods once per data count
    //   .append('g') // produces new groupings
    //   .append('rect')
    //   .attr('width', legendColorKeyWidth)
    //   .attr('height', legendColorKeyHeight)
    //   .attr('transform', (d, i) => {
    //     if (legendItemTotalWidth * (i + 1) >= totalWidth - 50) {
    //       legendWrappedItems.push(String(i));
    //     }

    //     if (legendWrappedItems.indexOf(String(i)) < 0) {
    //       return `translate(${legendItemTotalWidth * i}, ${15})`;
    //     }
    //     const wrappedIndex = legendWrappedItems.indexOf(String(i));
    //     return `translate(${legendItemTotalWidth * wrappedIndex}, ${42})`;
    //   })
    //   .style('fill', (d, i) => barColors[i]);
    // legendGrouping
    //   .data(legendCategoryNames)
    //   .enter()
    //   .append('text')
    //   .text(d => d)
    //   .attr('transform', (d, i) => {
    //     if (legendItemTotalWidth * (i + 1) >= totalWidth - 50) {
    //       legendWrappedItems.push(String(i));
    //     }
    //     if (legendWrappedItems.indexOf(String(i)) < 0) {
    //       const paddingLeft = legendColorKeyWidth * 1.25;
    //       return `translate(${legendItemTotalWidth * i + paddingLeft}, ${27})`;
    //     }
    //     const paddingLeft = legendColorKeyWidth * 1.25;
    //     const wrappedIndex = legendWrappedItems.indexOf(String(i));
    //     return `translate(${legendItemTotalWidth * (wrappedIndex) + paddingLeft}, ${55})`;
    //   });
  }

  // Legend Object Constructor
  // Central function to 'Create a new legend'
  // Requires 4 parameters
  // 1. chart - Chart you are targeting
  // 2. title - Title of legend you are generating
  // 3. categories - Each legend category
  // 4. colors - Each legend color
  // makeLegend() method that returns a DOM object  with child nodes injected
  function Legend(chart, title, categories, colors) {
    this.targetChart = chart;
    this.legendTitle = title;
    this.legendCategories = categories; // array
    this.legendColors = colors; // array

    //method to make actual legend
    this.makeLegend = () => {
      let barChart = this.targetChart;
      let legend = '<section class="new-legend">';
      let legendList = '<ul class="legend-list">';
      let legendListStacked = '<ul class="legend-list stacked">';
      let legendItem = '<li class="legend-item">';
      // Dont append legend title if empty string or null
      if (this.legendTitle !== '' || this.legendTitle === null) {
        let legendLabel = '<h5 class="legend-title">' + this.legendTitle + '</h5>';
        legend += legendLabel;
      }
      // if categories 4 or less, create inline version
      if (this.legendCategories.length <= 4) {
        legend += legendList;
        // else create stacked version
      } else {
        legend += legendListStacked;
      }
      for (let i = 0; i < this.legendCategories.length; i++) {
        legend += legendItem;
        legend += '<i class="legend-icon" style="background-color:' + this.legendColors[i] + '"></i>';
        legend += '<span class="legend-label">' + this.legendCategories[i] + '<span>';
        legend += '</li>';
      }
      legend += '</ul>';
      legend += '</section>';
      barChart.append(legend);
      return barChart;
    }
  }

  if (chartConfigObject.displayTrendChart === false && legendEntryCount === 1) {
    makeChartSingleBar();
  } else if (chartConfigObject.displayTrendChart === false && legendEntryCount >= 2) {
    makeChartMultiBar();
  } else if (chartConfigObject.displayTrendChart === true) {
    makeTrendChart(chartConfigObject, jsonData, lookup);
  }

}

export default makeChart;



// WEBPACK FOOTER //
// ./src/components/SP/SPChart.js